import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
//import { useParams } from "react-router-dom";
// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";

// Images
import bgImage from "assets/images/admin.png";
import {
  //CREATE_VOTING,
  DELETE_STRATEGYMAP,
  ALL_STRATEGYMAPS,
  LOCK_STRATEGYMAP,
} from "../queries";
/* eslint-disable react/prop-types */
const Strategymapsadmin = ({ setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [strategymaps, setStrategymaps] = useState([]);
  const [t] = useTranslation("common");
  //sectionss = useParams().id;
  let valittu = [];
  const strategymapss = useQuery(ALL_STRATEGYMAPS, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let strategymapsss = [];
    //let municipalitiess = [];
    if (strategymapss.data) {
      strategymapsss = strategymapss.data.allStrategymaps;
      //setOrgans(organss);
      //console.log(strategymapsss);
      setStrategymaps(strategymapsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [strategymapss]);
  //sectionss = useParams().id;
  if (strategymaps) {
    // eslint-disable-next-line
    valittu = strategymaps.filter(function (el) {
      return el.id === strategymapss;
    });
  }
  const [deletestrategymap] = useMutation(DELETE_STRATEGYMAP, {
    refetchQueries: [{ query: ALL_STRATEGYMAPS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addSTRATEGYMAP)
    }*/
  });
  //console.log(valittu);
  ////console.log(STRATEGYMAP.data)
  /*const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [{ query: ALL_VOTES }],
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },*/
  /*
    update: (store, response) => {
      updateCacheWith(response.data.addSTRATEGYMAP)
    }*/
  //});
  /*const uusi = async (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: { STRATEGYMAPid:event, userid: userid.length > 0 ? userid : "tyhjä", votedatetime:pvm.toString(), sectionid:sectionss }
      });
  };*/
  /*for(let i=0;i<valitut.length;i++){
    valitut[i].maara=0
    Object.preventExtensions(valitut)
  }*/
  //const maarat = aanetasiat => aanetasiat.reduce((prev, curr) => (prev[curr] = ++prev[curr] || 1, prev), {})s
  const [lockstrategymap] = useMutation(LOCK_STRATEGYMAP, {
    refetchQueries: [{ query: ALL_STRATEGYMAPS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addSTRATEGYMAP)
    }*/
  });
  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deletestrategymap({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  const setLocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockstrategymap({
      variables: { id: event, active: false },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockstrategymap({
      variables: { id: event, active: true },
    });
    //muutetaan activated !actived edituser
  };
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Strategiakartat Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {strategymaps.map((p) => (
                <>
                  <Button
                    key={p.meetingtext}
                    variant="contained"
                    size="normal"
                    color="inherit"
                    component={Link}
                    to={`/agendas/${p.id}`}
                  >
                    {p.municipality}; {p.id}: {p.maptext}
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa karttamerkinnän?")) {
                        setDelete(p.id);
                      }
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti lukita kommentin?")) {
                        setLocked(p.id);
                      }
                    }}
                  >
                    {t("common.lock")}
                  </Button>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa lukituksen kommentista?")) {
                        setUnlocked(p.id);
                      }
                    }}
                  >
                    {t("common.unlock")}
                  </Button>
                  <br />
                  <br />
                </>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
    </>
  );
};

export default Strategymapsadmin;
